import { Box } from '@chakra-ui/react';
import { KText } from 'ui-library/components';
import { JobSearchItem } from '../item/JobSearchItem';

export const JobList = ({ jobData, searchTerm }) => {
  return (
    <Box>
      <KText
        textTransform="uppercase"
        lineHeight="26px"
        letterSpacing="1px"
        px="16px"
        mb="md"
        size="sm-medium"
        color="secondary-900"
      >
        jobs results
      </KText>
      {jobData?.map((job, index) => {
        return (
          <JobSearchItem
            searchTerm={searchTerm}
            key={job.id}
            job={job}
            showBorderBottom={index !== jobData?.length - 1}
          />
        );
      })}
    </Box>
  );
};
